import { DEFAULT_SUBDOMAIN, DEFAULT_TENANT } from './constants'
import { platform } from '../device/platform'

const RESERVED_KEYWORDS = ['localhost', 'auraview', 'accounts', 'dev', 'testing', 'accountspreprodtech', 'accountspreprodagro', 'auraviewpreprodtech', 'auraviewpreprodagro']

export let tenant: Tenant

export async function initTenant (): Promise<Tenant> {
  tenant = await Tenant.create()
  return tenant
}

export class Tenant {
  public subdomain: string | null = DEFAULT_SUBDOMAIN
  public tenant: string = DEFAULT_TENANT

  constructor () {
    this.subdomain = this._getSubdomainFromURL()
    this.tenant = this._getTenantFromURL()
  }

  static async create (): Promise<Tenant> {
    const instance = new Tenant()
    await instance.resolveAccountsSubdomain()
    return instance
  }

  private _getFirstHostSegment (): string {
    const firstDotPosition = location.hostname.indexOf('.')
    return firstDotPosition > -1 ? location.hostname.slice(0, firstDotPosition) : location.hostname
  }

  private _isReservedHost (): boolean {
    return RESERVED_KEYWORDS.includes(this._getFirstHostSegment())
  }

  private _getSubdomainFromURL (): string | null {
    if (platform !== 'web') return DEFAULT_SUBDOMAIN ?? null
    const segment = this._getFirstHostSegment()
    if (RESERVED_KEYWORDS.includes(segment)) {
      return new URLSearchParams(location.search).get('s')
    }
    return segment
  }

  private _getTenantFromURL (): string {
    if (platform !== 'web') return DEFAULT_TENANT
    const firstSegment = this._getFirstHostSegment()
    return location.host.replace(firstSegment + '.', '').replace(/:\d+/, '')
  }

  async resolveAccountsSubdomain (): Promise<void> {
    if (!this._isReservedHost()) return
    if (new URLSearchParams(location.search).has('s')) return
    if (this.tenant === DEFAULT_TENANT) return

    try {
      const res = await fetch(`${this.getAPIBaseURL()}/api/workspaces/tenant`)
      const { data } = await res.json()
      this.subdomain = data.default_subdomain
      this.tenant = data.tenant ?? this.tenant
    } catch {
      // keep defaults on failure
    }
  }

  public getAPIBaseURL (urlBase: string = process.env.URL_API ?? `https://api.${process.env.DEFAULT_TENANT}`): string {
    return platform === 'web' ? urlBase.replace(DEFAULT_TENANT, this.tenant).replace(/:\d+/, '') : urlBase
  }
}
